define('config',[
	
],	function(){
	
	return {
		
	};
	
});
